"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var react_router_2 = require("react-router");
var common_1 = require("@epic-core/common");
function appRoutes(routeDefinition) {
    var path = common_1.getPath();
    var routes = routeDefinition.map(function (entry) {
        return __assign(__assign({}, entry), { key: entry.path, path: path + ":locale/" + entry.path });
    });
    return routes;
}
exports.appRoutes = appRoutes;
function getRoutes(routeDefinition, location) {
    var routes = appRoutes(routeDefinition);
    var locationObj = typeof location.toJS === 'function' ? location.toJS() : location;
    var routeSwitch = (react_1.default.createElement(react_router_2.Switch, { location: locationObj }, routes.map(function (pluginComponent) {
        return react_1.default.createElement(react_router_1.Route, __assign({ key: pluginComponent.key }, pluginComponent));
    })));
    return routeSwitch;
}
exports.getRoutes = getRoutes;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUm91dGVVdGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9Sb3V0ZVV0aWxzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLDZDQUFtQztBQUNuQyw2Q0FBb0M7QUFDcEMsNENBQTBDO0FBRTFDLFNBQWdCLFNBQVMsQ0FBQyxlQUFlO0lBQ3JDLElBQU0sSUFBSSxHQUFHLGdCQUFPLEVBQUUsQ0FBQztJQUN2QixJQUFNLE1BQU0sR0FBRyxlQUFlLENBQUMsR0FBRyxDQUFDLFVBQUEsS0FBSztRQUNwQyw2QkFDTyxLQUFLLEtBQ1IsR0FBRyxFQUFFLEtBQUssQ0FBQyxJQUFJLEVBQ2YsSUFBSSxFQUFLLElBQUksZ0JBQVcsS0FBSyxDQUFDLElBQU0sSUFDdEM7SUFDTixDQUFDLENBQUMsQ0FBQztJQUNILE9BQU8sTUFBTSxDQUFDO0FBQ2xCLENBQUM7QUFWRCw4QkFVQztBQUVELFNBQWdCLFNBQVMsQ0FBQyxlQUFlLEVBQUUsUUFBUTtJQUMvQyxJQUFNLE1BQU0sR0FBRyxTQUFTLENBQUMsZUFBZSxDQUFDLENBQUM7SUFDMUMsSUFBTSxXQUFXLEdBQUcsT0FBTyxRQUFRLENBQUMsSUFBSSxLQUFLLFVBQVUsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLElBQUksRUFBRSxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUM7SUFDckYsSUFBTSxXQUFXLEdBQUcsQ0FDaEIsOEJBQUMscUJBQU0sSUFBQyxRQUFRLEVBQUUsV0FBVyxJQUN4QixNQUFNLENBQUMsR0FBRyxDQUFDLFVBQUEsZUFBZTtRQUN2QixPQUFPLDhCQUFDLG9CQUFLLGFBQUMsR0FBRyxFQUFFLGVBQWUsQ0FBQyxHQUFHLElBQU0sZUFBZSxFQUFJLENBQUM7SUFDcEUsQ0FBQyxDQUFDLENBQ0csQ0FDWixDQUFDO0lBQ0YsT0FBTyxXQUFXLENBQUM7QUFDdkIsQ0FBQztBQVhELDhCQVdDIn0=